import cx from 'classnames';
import {useCallback} from 'react';
import {useSelector} from 'react-redux';
import {useGetCategories} from '~/common/components/MegaNav/MegaNavVariant/hooks/useGetCategories';
import type {TabsEnum} from '~/common/components/MegaNav/MegaNavVariant/types';
import {selectIsProOrPartyPass} from '~/common/fabric/User/reducers/user';
import {Link} from '~library/atoms/Link';
import {useTracking} from '~library/context/tracking/tracking-context';
import * as styles from './NavigationLinks.module.scss';

export const NavigationLinks = () => {
  const {currentGlobalNav, megaNavData} = useGetCategories();
  const isProOrPartyPass = useSelector(selectIsProOrPartyPass);
  const {track} = useTracking();

  // Get navigation items from globalNav, filtering out Evite Pro if user has Pro/PartyPass
  const navLinks =
    megaNavData?.globalNav
      ?.filter((nav) => {
        // Hide Evite Pro link if user already has Pro/PartyPass
        if (nav.id === 'evite-pro' && isProOrPartyPass) {
          return false;
        }
        return true;
      })
      .map((nav) => ({
        id: nav.id as TabsEnum,
        title: nav.title,
        url: nav.url,
      })) ?? [];

  const handleNavLinkClick = useCallback(
    (link: {id: TabsEnum; title: string; url: string}) => () => {
      track({
        dataQaId: `global-nav-${link.id}`,
        href: link.url,
        title: link.title,
        navId: link.id,
      });
    },
    [track]
  );

  return (
    <div className={styles.container}>
      {navLinks.map((link) => (
        <Link
          key={link.id}
          href={link.url}
          data-qa-id={`nav-bar-${link.id}`}
          className={cx(styles.link, {
            [styles.linkActive]: currentGlobalNav === link.id,
          })}
          onClick={handleNavLinkClick(link)}
        >
          {link.title}
        </Link>
      ))}
    </div>
  );
};
